import { useMemo } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

export interface BoundedTooltipProps extends TooltipProps {
  boundaryElement?: HTMLElement | null;
  padding?: number;
}

export const BoundedTooltip = ({
  boundaryElement,
  padding = 8,
  PopperProps,
  ...props
}: BoundedTooltipProps) => {
  const boundedPopperProps: TooltipProps['PopperProps'] = useMemo(() => {
    if (!boundaryElement) return PopperProps;

    const existingModifiers = PopperProps?.modifiers ?? [];
    const modifiers = existingModifiers.filter(
      (modifier) => modifier.name !== 'preventOverflow' && modifier.name !== 'flip',
    );

    return {
      ...PopperProps,
      container: boundaryElement,
      strategy: 'absolute',
      modifiers: [
        ...modifiers,
        {
          name: 'preventOverflow',
          options: {
            boundary: boundaryElement,
            padding,
            altAxis: true,
          },
        },
        {
          name: 'flip',
          options: {
            boundary: boundaryElement,
            padding,
          },
        },
      ],
    };
  }, [PopperProps, boundaryElement, padding]);

  return <Tooltip {...props} PopperProps={boundedPopperProps} />;
};
